// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root___IyO2","label":"Completed_label__IDVo4"};